import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';

const SymbolComponent = ({
  top,
  dispatchTop,
  componentSymbol,
  setOptionChoices,
  setOptionChains,
  finishedRenderingOptionChain,
  setFinishedRenderingOptionChain,
}) => {
  //let top = props.top;
  //let dispatchTop = props.dispatchTop;
  //let componentSymbol = props.componentSymbol;
  const [textSymbol, setTextSymbol] = useState(''); //need this here so that the this component rerenders when typed into
  const [prevSymbol, setPrevSymbol] = useState('');
  useEffect(() => {
    setPrevSymbol(top.symbol === undefined ? '' : top.symbol);
  }, [top.symbol]);

  return (
    <div>
      <TextField
        id="outlined-basic"
        size={'small'}
        autoComplete={false}
        // label={<Typography style={{fontSize: 10}}> Symbol < /Typography>}
        //variant="outlined"
        margin={'none'}
        InputProps={{ font: 1 }}
        placeholder={'symbol...'}
        value={componentSymbol.current}
        onChange={(ev) => {
          setTextSymbol(ev.target.value);
          componentSymbol.current = ev.target.value;
          //bufferSymbol(dispatchTop, ev.target.value);
        }}
        onBlur={(ev) => {
          dispatchTop({ symbol: ev.target.value });
          //console.log("blurring symbol");
          //console.log(prevSymbol.toUpperCase());
          //console.log(ev.target.value.toUpperCase());
          //console.log(top.instrument)
          if (prevSymbol.toUpperCase() !== ev.target.value.toUpperCase()) {
            setOptionChoices({});
            setOptionChains({});
            setPrevSymbol(ev.target.value);
            if (top.instrument === 'option') {
              if (
                finishedRenderingOptionChain &&
                setFinishedRenderingOptionChain
              ) {
                setFinishedRenderingOptionChain(false);
                //console.log("setting to false");
                //console.log(finishedRenderingOptionChain);
              }
            }
          }
        }}
        //required
      />
    </div>
  );
};

export default SymbolComponent;
